import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    layout: 'mt-9 flex justify-between gap-10 max-md:flex-col',
    main: 'flex max-w-200 grow flex-col',
    sections: 'mt-8 flex grow flex-col gap-10 sm:mt-10 sm:gap-15',
    sectionTitle: 'heading-l-regular mb-5',
    faqWrapper: 'bg-secondary mt-10 px-4 py-8 md:mt-25 md:p-15',
    faqTitle: 'heading-2xl md:heading-3xl mb-4 md:mb-8',
    faqContent: 'flex flex-col gap-4 border-y-0 md:gap-8',
    faqContentHeader: 'pt-3 md:mr-0 md:px-0 md:pt-2 md:pl-0',
    faqContentItem: 'md:px-0',
    summary: 'relative grow md:max-w-80 lg:max-w-95 xl:max-w-105',
    title: 'sm:heading-italic-l heading-italic-m',
    sentinel: 'pointer-events-none absolute top-0 right-0 left-0'
  }
});
